const PrevSlideButton = () => (
    <div className="promotions__swiper-button-prev" tabIndex="0" role="button" aria-label="Previous slide">
        <i className="icon icon--arrow-left" role="desktop-visible" />
    </div>
);

export default PrevSlideButton;
